// return "demo.api.altius.finance";
// return "fo1-dev.api.altius.finance";

export const getDomain = () => {
  if (import.meta.env.DEV) {
    return import.meta.env.VITE_API_HOST || "fo1.api.altius.finance"; // staging
  }

  const hostname = window.location.hostname; // fo1.altius.finance
  const insertedApiString = hostname.replace(".", ".api."); // fo1.api.altius.finance

  if (import.meta.env.VITE_NODE_ENV === "production") {
    return insertedApiString.replace("finance", "capital"); // fo1.api.altius.capital
  }

  return insertedApiString;
};

export const getProtocol = (): string => {
  return import.meta.env.VITE_PROTOCOL || "https://";
};

export const getClientDomain = () => {
  return location.host;
};
